import { useEffect } from "react";
import { createPortal } from "react-dom";

const SIZE_CLASS = {
  sm: "",
  md: "modal-md",
  lg: "modal-lg",
  xl: "modal-xl",
};

/**
 * Full-viewport overlay shell. Always mounts on document.body so glass
 * cards / sidebars cannot trap position:fixed.
 */
const WljOverlayModal = ({
  children,
  className = "",
  size = "sm",
  style,
  ...rest
}) => {
  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    document.body.classList.add("modal-open");

    return () => {
      document.body.style.overflow = previousOverflow;
      document.body.classList.remove("modal-open");
    };
  }, []);

  if (typeof document === "undefined") return null;

  const sizeClass = SIZE_CLASS[size] || "";

  return createPortal(
    <div
      className={`modal fade show wlj-overlay-modal ${sizeClass} ${className}`.trim()}
      tabIndex="-1"
      role="dialog"
      style={{ display: "flex", ...style }}
      {...rest}
    >
      {children}
    </div>,
    document.body
  );
};

export default WljOverlayModal;
